import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash-es';

import { SortableTable } from '../../../../components/SortableTable';
import ProgressBar from '../../../../components/HorizontalBars/ProgressBar';

const columns = [
  { dataField: 'logo', text: '', style: { width: '30%' } },
  { dataField: 'name', sortBy: 'name', text: 'SDK Name', sortable: true, style: { width: '30%' } },
  {
    dataField: 'usage',
    sortBy: 'usage',
    sortable: true,
    text: 'SDK Usage',
    tooltipText: "The % of this publisher's apps that have this SDK Installed",
  },
];
const getSdkKey = (name) =>
  name
    .toString()
    .replace(/[^\d\w]/g, '')
    .replace(/_/g, '')
    .toLowerCase()
    .replace(/logo/g, '');

const default_icon_url = 'https://d1cxddrn475swp.cloudfront.net/sdk-default-ico.png';

const sdkIconUrl = (store, name) =>
  `https://d1cxddrn475swp.cloudfront.net/frameworks/${store}/${name}.jpg`;

const SdkCategoryTable = ({ sdks }) => {
  const rows = useMemo(
    () =>
      orderBy(sdks, ['usage'], ['desc']).map((sdk) => ({
        key: getSdkKey(sdk.name),
        logo: (
          <img
            className="img-fluid publisher_page_sdks__icon"
            src={sdkIconUrl(sdk.store, getSdkKey(sdk.name))}
            alt={sdk.name}
            onError={(e) => {
              e.currentTarget.src = default_icon_url;
            }}
          />
        ),
        name: sdk.name,
        name_display: sdk[sdk.store]?.id ? (
          <a href={`/sdks/${sdk.store}/${sdk[sdk.store].id}`}>{sdk.name}</a>
        ) : (
          <span>{sdk.name}</span>
        ),
        usage: sdk.usage,
        usage_display: (
          <ProgressBar percentage={sdk.usage} barWidth="calc(100% - 75px)" textWidth={50} />
        ),
      })),
    [sdks]
  );

  return (
    <div className="table-responsive p-l p-r">
      <SortableTable
        tableClassName="table table-lg table-bordered-x"
        columns={columns}
        rows={rows}
        defaultSortBy="usage"
        hasShowMoreCell={false}
        showEmptyCells={false}
        initialRowsLimit={rows.length}
      />
    </div>
  );
};

SdkCategoryTable.propTypes = {
  sdks: PropTypes.array.isRequired,
};

export default SdkCategoryTable;
